import axios from "axios";

export interface IDisambiguation {
    booking: any;
    bookingDisambiguation: any;
}

export const getDisambiguation = async (disambiguationId: string | undefined): Promise<IDisambiguation> => {
    const response = await axios.get('/booking/import/getDisambiguation', {params: {disambiguationId}});
    return response.data;
};
